// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"dbb0cae2","183":"dbb0cae2","858":"dbb0cae2","927":"dbb0cae2","949":"dbb0cae2"}[chunkId] + ".chunk.css";
};